// EXTERNAL LINKS
export const ABILITY_NET_MCMW_URL = 'https://mcmw.abilitynet.org.uk';
export const CBP_URL = 'https://www.cbp-bf.com/auth/login';
export const EQUALITY_ADVISORY_SERVICE_URL = 'https://www.equalityadvisoryservice.com';
export const EQUALITY_NI_URL = 'https://www.equalityni.org/Home';
export const GOVUK_URL = 'https://gov.uk';
export const PASSWORD_GUIDANCE_URL = 'https://www.ncsc.gov.uk/collection/top-tips-for-staying-secure-online/three-random-words#:~:text=Why%20does%20the%20NCSC%20recommend,enough%20for%20you%20to%20remember';
export const WCAG_22_URL = 'https://www.w3.org/TR/WCAG22';
export const BIC_PRIVACY_URL = 'https://www.gov.uk/government/publications/personal-information-use-in-borders-immigration-and-citizenship';

// INTERNAL LINKS
export const SERVICE_URL = 'https://int.nmsw.homeoffice.gov.uk/sign-in';

// REGISTER/SIGN IN PAGES
export const LANDING_URL = '/';
export const SELECT_SERVICE_URL = '/select-service';
export const SIGN_IN_URL = '/sign-in';
export const ACTIVATE_ACCOUNT = '/activate-account'; // added as this as it's the UX preferred url for the email, it currently loads /your-details
export const REGISTER_DETAILS_URL = '/create-account/your-details';
export const RESEND_INVITATION_URL = '/resend-invitation';
export const RESEND_INVITATION_CHECK_YOUR_EMAIL_URL = '/resend-invitation/check-your-email';

// PASSWORD RESET
export const REGISTER_PASSWORD_URL = '/create-account/your-password';
export const REQUEST_PASSWORD_RESET_URL = '/forgotten-password'; // back button
export const REQUEST_PASSWORD_RESET_CONFIRMATION_URL = '/forgotten-password/check-your-email';
export const RESET_YOUR_PASSWORD = '/new-password'; // this is a logged out version

// TOP LEVEL NAV
export const REPORTED_VOYAGES_DASHBOARD_URL = '/dashboard';
export const YOUR_SETTINGS_URL = '/your-settings';
export const DELETE_GROUP_MEMBER_URL = '/del-group-member';
export const DELETE_ACCOUNT_SUCCESS_URL = '/account/delete-confirmation';
export const DELETE_USER_URL = '/delete-user';

// SPCR Internal
export const SPCR_DASHBOARD_URL = '/spcr-dashboard';
export const SPCR_REVIEW_REPORT_URL = '/review-report';
export const MANAGE_USERS_URL = '/manage-users';

// DECLARATIONS
export const DECLARATION_URL = '/declaration'; // back button

// TEAM INVITATIONS
export const INVITE_USER_URL = '/invite-user'; // back button
export const INVITE_USER_CHECK_ANSWERS_URL = '/invite-user/check-your-answers';
export const INVITE_USER_CONFIRMATION_URL = '/invite-user/team-member-invited';

// ERROR MESSAGE
export const MESSAGE_URL = '/message';

// HELP PAGES (footer links)
export const ACCESSIBILITY_URL = '/accessibility-statement';
export const PRIVACY_URL = '/privacy';
export const COOKIES_URL = '/cookies';
export const HELP_URL = '/help';

export const NO_LAYOUT_PAGES = [];

// Top level pages - we use this to know to clear form session data
export const TOP_LEVEL_PAGES = [
  LANDING_URL,
  MANAGE_USERS_URL,
  YOUR_SETTINGS_URL,
  SPCR_DASHBOARD_URL
];

export const PAGES_WITH_BACK_LINKS = [
  DECLARATION_URL,
  REGISTER_PASSWORD_URL,
  REQUEST_PASSWORD_RESET_URL,
  INVITE_USER_URL,
  DELETE_USER_URL,
  SIGN_IN_URL,
];
